import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/authcontext';
import styles from './sidebar.module.css';

function Sidebar() {
  const navigate = useNavigate();
  const { user, subscriptionTier, logout } = useAuth();

  const handleSignOut = async (e) => {
    e.preventDefault(); // Prevent default button behavior
    console.log('Sidebar: Sign Out button clicked');
    
    try {
      // Remove cached user first for immediate feedback
      localStorage.removeItem('zenbidup_user');
      console.log('Sidebar: Removed cached user');
      
      // Navigate before actually signing out to prevent timeout
      console.log('Sidebar: Redirecting to login page before logout');
      navigate('/login');
      
      // Perform the actual logout in the background
      setTimeout(() => {
        logout().catch(error => {
          console.error('Sidebar: Error during delayed logout:', error);
        });
      }, 100);
    } catch (error) {
      console.error('Sidebar: Error during sign out process:', error);
    }
  };

  const handleNavigation = (path) => {
    console.log('Sidebar: Navigating to', path);
    try {
      navigate(path);
    } catch (error) {
      console.error('Sidebar: Navigation error:', error);
      // Fallback - use direct location change if React Router fails
      window.location.href = path;
    }
  };

  return (
    <div className={styles.sidebar}>
      <div className={styles.logoContainer}>
        <img src="/zenbuildlogo.png" alt="Company Logo" className={styles.logoImg} />
      </div>
      <nav className={styles.nav}>
        <button 
          className={`${styles.navButton} ${styles.bidTrackerButton}`} 
          onClick={() => handleNavigation('/dashboard')}
        >
          Bid Tracker
        </button>
        <button className={styles.navButton} onClick={() => handleNavigation('/dashboard?new=project')}>
          New Project Bid
        </button>
        <button className={styles.navButton} onClick={() => handleNavigation('/dashboard?new=standalone')}>
          New Standalone Bid
        </button>
        <button onClick={() => handleNavigation('/address-book/clients')} className={styles.navButton}>
          Client Address Book
        </button>
        <button onClick={() => handleNavigation('/address-book/subcontractors')} className={styles.navButton}>
          Sub Address Book
        </button>
        <button onClick={() => handleNavigation('/analytics')} className={styles.navButton}>
          Analytics
        </button>
        <div className={styles.versionText}>V2.01</div>
      </nav>
      <div className={styles.actions}>
        <button className={styles.signOutButton} onClick={handleSignOut}>
          Sign Out
        </button>
      </div>
    </div>
  );
}

export default Sidebar; 